import { memo, useMemo } from "react";
import { Box, Text } from "@storyofams/react-ui";

export const SkinTypes: React.FC<any> = memo(({ product }) => {
  const skinTypes: string[] | null = useMemo(() => {
    const skinType2: string = product?.metafields?.find(
      (item) => item?.key === "huidaandoening"
    )?.value;
    const skinType3: string = product?.metafields?.find(
      (item) => item?.key === "huidtype"
    )?.value;
    if (!skinType2 && !skinType3) return null;
    if (!skinType2) return skinType3.split("|");
    if (!skinType3) return skinType2.split("|");
    else return (skinType2 + "|" + skinType3).split("|");
  }, []);
  if (!skinTypes) return null;
  return (
    <Box mb={2}>
      <Text color="grey600">Geschikt voor</Text>
      <Box display="flex" flexWrap="wrap" mb={1}>
        {skinTypes &&
          skinTypes.map((type) => (
            <Box
              key={type}
              height="24px"
              borderRadius={"5px"}
              border="1px solid grey200"
              pt={"3px"}
              px={"5px"}
              mr={1}
              mt={1}
              fontSize="13px"
              fontWeight={600}
            >
              {type.toUpperCase()}
            </Box>
          ))}
      </Box>
    </Box>
  );
});
